import { Component, HostListener, Inject, Injectable, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CMSModel } from 'src/app/Models/CMSModel';
import { CacheService } from 'src/app/services/cache.service';
import { CmsService } from 'src/app/services/cms.service';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/services/notification.service';
import { MetaContentService } from 'src/app/services/meta-content.service';
import { CMSNavigationService } from 'src/app/services/cms-navigation.service';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { NotificationType } from 'src/app/enum/NotificationType';
import { Registration } from 'src/app/Models/RegistrationModel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationComponent } from 'src/app/popupModel/registration/registration.component';
import { SourceIdEnum } from 'src/app/Models/sourceIdEnumModel';
import { CmsJsService } from 'src/app/services/cmsJS.service';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { Location } from '@angular/common';
import intlTelInput from 'intl-tel-input';
import { CountryCodeModel } from 'src/app/Models/CountryCode.Model';
import { LeadFormTitle } from 'src/app/enum/LeadFormTitle';
// import telUtils from "node_modules/intl-tel-input/build/js/utils";
declare var $: any;
@Component({
  selector: 'app-cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.css'],
  encapsulation: ViewEncapsulation.None,
})
@Injectable({
  providedIn: 'root',
})
export class CmsComponent implements OnInit {
  sourceId: SourceIdEnum = SourceIdEnum.CMSDefault;
  cmsContent!: CMSModel;
  cmsContentToload?: string;
  cmsHtmlContent?: string;
  // chunkSize: number = 100;
  // offsetToStart: number = 0;
  // offsetToend: number = 4000;
  CMShideBlock!: boolean;
  userDetails: any;
  UserId!: any;
  gradeId: any;
  separateDialCode = true;
  MSG = 'Hello';
  sourceURL!: string;
  testSourceURL!: string;
  eventControl: any;
  hashUrl!: string;
  userID!: number;
  registration!: Registration;
  previousURL: string = '';
  urlToRedirect: string = '';
  link!: HTMLLinkElement;
  script!: HTMLScriptElement;
  isNRIPageCSS = '';
  showBookDemoLink = false;
  ContactUs!: any;
  routerSubscription: any;
  cacheSubscription: any;
  eventView: any;
  startTime!: number;
  endTime!: number;
  isSatPage: boolean = false;
  isCMS = 'CMS';
  isIntlTelInputInitialized = false;
  isLoading: boolean = false;
  pageTitle = LeadFormTitle.CMS;

  skipURLList: string[] = [
    'home',
    'package',
    'resource-page-component',
    'one-to-one-live-classes',
    'resource-details-component',
    'forums',
    'page-not-found',
    'askiitians',
    'blog',
    'user',
    'resources/images/',
    'resources',
    'assets/css/',
    'assets/js/',
    'payment-credit-debit-component',
  ];
  skipResources: string[] = [
    'header.component.css.map',
    'resource-page-component',
    'one-to-one-live-classes',
    'resource-details-component',
    'payment-credit-debit-component',
    '/resources/images/',
    '/assets/css/',
    '/assets/js/',
  ];

  cssobj = {
    NRIPage: [
      '/assets/css/nriPage.css',
      '/assets/css/owl.carousel.min.css',
      '/assets/css/owl.theme.default.min.css',
      '/assets/js/owl.carousel.min.js',
      '/assets/css/animate.css',
      'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css',
      'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.css',
      'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js',
    ],
    'academic-experts-profile.aspx': ['/assets/css/cms_data.css'],
  };
  headers: HttpHeaders | undefined;
  // show book now link for mobile view on scrolll
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(ev: any) {
    if (ev.currentTarget.pageYOffset > 0) {
      this.showBookDemoLink = true;
    } else {
      this.showBookDemoLink = false;
    }
  }
  constructor(
    private cmsService: CmsService,
    private router: Router,
    private cacheService: CacheService,
    private notificationService: NotificationService,
    private metaService: MetaContentService,
    private cmsNavigationService: CMSNavigationService,
    private jsService: CmsJsService,
    private modalService: NgbModal,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private dom: any,
    private location: Location
  ) {
    this.routerSubscription = router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.eventView = ev;

        if (this.previousURL != this.eventView.url) {
          this.previousURL = this.eventView.url;
          this.getCMSPost();
        }
      }
    });
  }
  ngOnInit() {
    this.cacheSubscription = this.cacheService._userDetails.subscribe((res) => {
      this.userDetails = null;
      this.UserId = null;
      if (res != null) {
        this.userDetails = res;
        this.UserId = this.userDetails.id;
        this.gradeId = this.userDetails.userdetails.grade;
      }
    });
  }

  getCMSPost() {
    this.isLoading = true;
    const isSkipUrl = this.skipURL();

    if (!isSkipUrl) {
      this.hashUrl = this.previousURL.split('#')[1];
      this.previousURL = this.previousURL.split('#')[0];
      const url =
        '~' +
        this.previousURL +
        (this.previousURL.search('.html') > 0 ||
        this.previousURL.search('.aspx') > 0 ||
        this.previousURL.search('.htm') > 0 ||
        this.previousURL.endsWith('/') ||
        this.previousURL == '/robots.txt'
          ? ''
          : '/');
      const urlToReplaceState = url.slice(1);

      this.location.replaceState(urlToReplaceState);
      this.cmsService.getPost(url).subscribe({
        next: (res) => {
          if (res.redirectionrule && res.redirectionUrl) {
            let urlToRedirect = res.redirectionUrl ? res.redirectionUrl.slice(1) : '';

            this.previousURL = urlToRedirect;
            this.location.replaceState(urlToRedirect);
            window.location.href = urlToRedirect;
          } else {
            this.renderData(res);
          }
        },
        error: (error) => {
          if (isPlatformServer(this.platformId)) {
            this.transferState.set<HttpErrorResponse>(makeStateKey(url), error);
          }
          if (error instanceof HttpErrorResponse) {
            this.router.navigate(['page-not-found', { status: error.status }], {
              skipLocationChange: true,
            });
          }
        },
      });
    } else {
      this.router.navigate([this.previousURL]);
    }
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  renderData(res: any) {
    this.cmsContent = res;
    this.cacheService.setIsCMSPage(this.cmsContent.isrightpanel);
    this.isNRIPageCSS = this.cmsContent.isrightpanel ? 'isNotNRIPage' : 'isNRIPage';
    var key = this.cmsContent.source?.replace(/^~\//, '').replace(/\/$/, '') ?? '';
    var countryList = [
      'indonesia',
      'singapore',
      'uae',
      'oman',
      'usa',
      'kuwait',
      'saudi-arabia',
      'qatar',
      'bahrain',
      'malaysia',
      'uganda',
      'iit-jee-coaching-in-al-ain',
      'iit-jee-coaching-in-ajman'
    ];
    var countryName = key.split('/')[0];
    var modifiedKey = countryList.includes(countryName) ? 'NRIPage' : key;
    var csslist = this.cssobj[modifiedKey as keyof typeof this.cssobj];
    this.RemoveBackgroundImage();
    if (csslist != undefined) {
      this.loadCSS(csslist);
    }
    if (isPlatformBrowser(this.platformId)) {
      if (this.hashUrl != null && this.hashUrl != undefined) {
        const element = this.dom.getElementById(this.hashUrl);
        element?.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (modifiedKey == 'NRIPage') {
      this.isLoading = false;
      this.NRIslider();
    }
    if (this.cmsContent.source == '~/sat/') {
      this.bxslider();
      this.isSatPage = true;
      this.cacheService.SetisSatPage(true);
    } else if (this.cmsContent.source == '~/resultspage.aspx') {
      this.addCarousalToBanner();
    } else if (
      countryList.includes(countryName) &&
      (this.cmsContent.isrightpanel == null || !this.cmsContent.isrightpanel)
    ) {
      this.jsService.jsEnable();
    }
    if (this.cmsContent.id != null && this.cmsContent.id != undefined) {
      //hide right block
      let index = res.index == null ? 'null' : res.index ? 'index' : 'noindex';
      let follow = res.follow == null ? 'null' : res.follow ? 'follow' : 'nofollow';
      let robot = `${index},${follow}`;
      this.metaService.updateCMSMetaContent (
        this.cmsContent.seoKeywords,
        this.cmsContent.seoDescription,
        this.cmsContent.seoTitle,
        this.cmsContent.canonicaltag?.slice(2),
        robot,
        this.dom,
        res.headerSchema
      );
    }
    this.isLoading = false;
  }

  skipURL() {
    const lowerCasePreviousURL = this.previousURL.toLowerCase();
    const isSkip =
      this.skipURLList.filter((u) => {
        const lowerCaseURLFragment = '/' + u.toLowerCase();
        //  console.log(`URL fragment: ${lowerCaseURLFragment}, lowerCasePreviousURL:${lowerCasePreviousURL}`); // Log the current value of 'u'
        return lowerCasePreviousURL === lowerCaseURLFragment;
      }).length > 0;
    return isSkip;
  }

  skipResourceURL() {
    const isSkip = this.skipResources.some((u) => {
      // console.log('Checking URL fragment:', u); // Log the current value of 'u'
      return this.previousURL.includes(u);
    });
    return isSkip;
  }
  getCMSDatahref(eventControl: any) {
    this.previousURL = window.location.pathname;
    this.eventControl = eventControl;
    if (this.eventControl.target.className == 'btn btn-success book-now') {
      this.cmsNavigationService.goToNavigation(eventControl, this.userDetails);
    } else if (
      this.eventControl.srcElement.className == 'fa fa-angle-down' ||
      this.eventControl.srcElement.className == 'fa fa-angle-up'
    ) {
      this.cmsNavigationService.collapseExploreBtn(eventControl);
    } else if (
      this.eventControl.target.className == 'header-jc-cta tempUrl book-freeClass' ||
      this.eventControl.target.id == 'leadSubmit'
    ) {
      if (this.eventControl.target.id == 'leadSubmit') {
        this.cmsNavigationService.submitParentQuey(document);
      } else {
        this.cmsNavigationService.bookAFreeClass(this.userDetails);
      }
    } else if (
      this.eventControl.srcElement.className == 'btn btn-default contactUsBtn' &&
      this.previousURL == '/contact-us.aspx'
    ) {
      this.validateContactUs();
    } else if (
      eventControl.target.id == 'leadSubmit' ||
      this.eventControl.target.className == 'btn btn-default header-jc-cta mt-10'
    ) {
      this.cmsNavigationService.submitParentQuey(document);
    } else if (eventControl.srcElement.className == 'tablink' && eventControl.target.name != null) {
      this.jsService.tabshideshow(eventControl);
    } else if (eventControl.srcElement.className == 'orng-btn register') {
      //to submit nri form lead
      this.cmsNavigationService.NRILeadSubmit(eventControl, document);
    } else {
      this.cmsNavigationService.goToCMSPDF(eventControl, this.previousURL);
    }
  }
  loadCSS(csslist: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (Array.isArray(csslist)) {
        for (let n = 0; n < csslist.length; n++) {
          const file = csslist[n];
          const isCSS = file.endsWith('.css');
          const isJS = file.endsWith('.js');
          if (isCSS) {
            this.link = this.dom.createElement('link');
            this.link.setAttribute('rel', 'stylesheet');
            this.dom.head.appendChild(this.link);
            this.link.setAttribute('href', file);
          } else if (isJS) {
            this.script = this.dom.createElement('script');
            this.dom.head.appendChild(this.script);
            this.script.setAttribute('src', file);
          }
        }
      }
    }
  }
  bookLiveClass() {
    const sourceId = SourceIdEnum.FreeDemo;
    const modelRef = this.modalService.open(RegistrationComponent, { centered: true, backdrop: 'static' });
    modelRef.componentInstance.sourceId = sourceId;
    modelRef.componentInstance.isShowCrossbtn = true;
    modelRef.componentInstance.pageTitle = LeadFormTitle.CMS;
    modelRef.componentInstance.isRegistered.subscribe((isRegistered: any) => {
      if (isRegistered == true) {
        this.cacheService.setIsUserLoggedIn(true);
        this.notificationService.notifyMessage(NotificationType.Success, `You're successfully logged in!`);
      } else {
        this.cacheService.setIsUserLoggedIn(true);
        this.notificationService.notifyMessage(NotificationType.Success, `You're Register Successfully!`);
      }
    });
  }
  onKeyDown(eventData: any) {
    if (isPlatformBrowser(this.platformId)) {
      let eventId = eventData.target.id;
      let eventErrorId = document.getElementById(eventId + '_error');
      if (eventErrorId != null) {
        document.getElementById(eventId + '_error')?.classList.remove('contact-us-non-error');
        document.getElementById(eventId + '_error')?.classList.add('contact-us-error');
      }
    }
  }
  validateContactUs() {

    if (isPlatformBrowser(this.platformId)) {
      this.ContactUs = {
        name: this.dom.getElementsByName('firstname')[0].value,
        email: this.dom.getElementsByName('email')[0].value,
        phoneNo: this.dom.getElementsByName('Phonenum')[0].value,
        message: this.dom.getElementsByName('message')[0].value,
      };
      if (
        this.ContactUs.name != '' &&
        this.ContactUs.email != '' &&
        this.ContactUs.phoneNo != undefined &&
        this.ContactUs.message != ''
      ) {
        this.cmsNavigationService.validationOnContactUsPage(document);
      } else {
        this.cmsNavigationService.validationOnContactUsPageFromClientSide(this.ContactUs, document);
      }
    }
  }
  bxslider() {
    setTimeout(() => {
      try {
        $('#slider1').bxSlider({
          mode: 'horizontal',
          slideMargin: 10,
          minSlides: 1,
          maxSlides: 2,
          moveSlides: 1,
          slideWidth: 280,
          slideHeight: 115,
          auto: true,
        });
      } catch (ex) {
        setTimeout(() => {
          $('.bx-loading').remove();
        }, 1000);
      }
    }, 1000);

    let body = this.dom.querySelector('body');
    if (body) {
      body.style.backgroundImage = 'url("/assets/images/top-banner.jpg")';
      body.style.backgroundRepeat = 'no-repeat';
      body.style.backgroundPosition = 'top center';
      body.style.backgroundColor = '#fff';
      // body.style.backgroundImage.
    }
  }
  NRIslider()
  {
    
    setTimeout(() => {
      this.jsService.jsEnableForNRISlider();
      this.jsService.tabshideshow(null);
    }, 2000);
    
  }
  addCarousalToBanner() {
    $(document).ready(function () {
      setTimeout(() => {
        $('.add-owl-carousel').owlCarousel({
          items: 1,
          loop: true,
          margin: 10,
        });
      }, 1000);
    });
  }
  RemoveBackgroundImage() {
    let body = this.dom.querySelector('body');
    if (body) {
      body.style.backgroundImage = '';
      this.cacheService.SetisSatPage(false);
    }
  }

  ngAfterViewInit() {

    //this.initializeIntlTelInput();
    //window.addEventListener('scroll', this.onScroll.bind(this));
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('scroll', this.onScroll.bind(this));
    }


  }
  initializeIntlTelInput() {


    if (this.isIntlTelInputInitialized) {
      return;
    }
    const input = document.getElementById('mobile') as HTMLInputElement;
    if (input) {
      intlTelInput(input, {
        initialCountry: "auto",
        nationalMode: false,
        countrySearch: false,
        separateDialCode: true,
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
        geoIpLookup: (callback) => {
          $.get('https://ipinfo.io', function () { }, "jsonp").always((resp: { country: any; }) => {
            const countryCode = (resp && resp.country) ? resp.country : "us";
            callback(countryCode);
          });
        },
      });
      this.isIntlTelInputInitialized = true;
    }
  }
  onScroll() {

    this.initializeIntlTelInput();
  }
}
